import Checkout from 'components/Checkout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import MinimalLayout from 'components/MinimalLayout';
import Plan from 'types/Plan';
import * as styles from './CheckoutRoute.module.scss';

type Props = {
  annualPlan: Plan;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  plans: Plan[];
  userId: number;
  whenExpired: string;
};

export default function CheckoutRoute({ annualPlan, coupon, currencyCode, plans, userId, whenExpired }: Props) {
  return (
    <MinimalLayout>
      <Checkout
        annualPlan={annualPlan}
        className={styles.content}
        coupon={coupon}
        currencyCode={currencyCode}
        initialPlan={plans[0]}
        userId={userId}
        whenExpired={whenExpired}
      />
    </MinimalLayout>
  );
}
